export default "__VITE_ASSET__LSer$NiG__"